import React from 'react';
import { connect } from 'react-redux';

import { toggleModalWithTimer } from 'apps/auth/actions/appAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_CARD_CREATE_PREVIEW, AUTH_GA_CARDS, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const GetVirtualPreviewPage = (props) => {
    const { fromReissue = false } = useExtra();
    const messages = usePageMessages();

    const topButtonLink = fromReissue ? AUTH_SEND_MAIN_LINK : AUTH_GA_CARDS;
    const iconName = fromReissue ? 'card-thin-cloud' : 'cardp-mastercard-thin';
    const headerText = fromReissue ? messages.fromReissueTitle : messages.orderOnlyVirtual;
    const secondaryText = fromReissue ? messages.fromReissueSubtitle : '';
    const primaryButtonCaption = fromReissue ? messages.getNowButton : messages.activateVirtualButton;

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName={iconName}
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={headerText} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={secondaryText} />}
                topButtonType="link"
                topButtonCaption={messages.notNow}
                topButtonLink={topButtonLink}
                primaryButtonCaption={primaryButtonCaption}
                primaryButtonType="button"
                primaryButtonOnClick={() => {
                    props.toggleModalWithTimer(true, messages.messageCardActivated, () => {
                        window.location.href = AUTH_GA_CARD_CREATE_PREVIEW;
                    });
                }}
            />
        </BaseLayout>
    );
};

export default connect(null, { toggleModalWithTimer })(BasePage(GetVirtualPreviewPage));
